import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertNotificationService {
  private _alertCount = new BehaviorSubject<number>(0);
  alertCount$ = this._alertCount.asObservable();

  private hasNotificationsSubject = new BehaviorSubject<boolean>(false);
  hasNotifications$ = this.hasNotificationsSubject.asObservable();

  setHasNotifications(value: boolean) {
    this.hasNotificationsSubject.next(value);
  }

  // Mock data (later replace with API call result)
  private mockData = {
    usercount: 25,
    errorRate: 2,
    transactionTime: 1500
  };

  checkAlerts() {
    let triggered = 0;

    // Example rules
    if (this.mockData.usercount > 20) triggered++;
    if (this.mockData.errorRate > 5) triggered++;
    if (this.mockData.transactionTime > 1000) triggered++;

    this._alertCount.next(triggered);
  }
}
